import React, {useState} from "react";
import {IonImg} from "@ionic/react";
import { AvatarSvg } from "./AvatarSvg";


const ChatAvatar = ({chat}) => {
  const [error, setError] = useState(false);
  const hashCode = (str) => {
    let hash = 0, i, chr;
    if (!str || str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;

    }
    return hash;
  };
  const hash = hashCode(chat?.name)
  const number = Math.abs(hash % 9);

  // let matches = chat?.name.split(' ').map(item => item[0]).join('')
  // if (matches?.length > 2) {
  //   matches = matches.slice(0, 1)
  // }

  const avatarNumber = () => {
    const res = (chat.name.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '').charCodeAt(0) % 20).toString()
    return !!res && res !== "NaN" ? res.length === 1 ? `0${res}` : res : '00';
  }

  return <>
    {chat?.avatar_url && !error && <IonImg alt='avatar' onIonError={(data) => {
      setError(true)
    }} src={chat.avatar_url}/>}
    {(!chat?.avatar_url || error) &&
      <div alt='avatar' className={`i-chats-list-item-avatar i-chats-list-item-avatar-${number}`}>
        {/* <div className='i-chats-list-item-avatar-text'>{matches}</div> */}
        <AvatarSvg id={avatarNumber()} />
      </div>}
  </>
}


export default React.memo(ChatAvatar);
